import { type AppDispatch } from "features/Application/globaltypes/redux";
import { errStates, gotStates } from "../slices/statesSlice";
import typedDataService from "../../../../../Application/services/dataServices/typedDataService";

export const fetchStates = () => async (dispatch: AppDispatch) => {
  try {
    const states = await typedDataService.payments.getStateList();
    dispatch(gotStates(states));
  } catch (error) {
    dispatch(errStates("Failed to load states. Please try again later."));
  }
};
